import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-layout-memorial',
  imports: [RouterModule],
  templateUrl: './layout-memorial.html',
})
export class LayoutMemorial {}
